import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import ld2 from "../images/ld2.jpg";
import bopp4 from "../images/bopp4.jpg";
import hm2 from "../images/hm2.webp";
import pof1 from "../images/pof1.jpg";

const products = [
  {
    image: bopp4,
    name: "BOPP",
    fullname: "Biaxially Oriented Polypropylene",
    link: "1",
    tag: "Most Popular",
  },
  {
    image: pof1,
    name: "POF",
    fullname: "Polyolefin Shrink Films",
    link: "2",
    tag: null,
  },
  {
    image: ld2,
    name: "LD",
    fullname: "Low Density Polyethylene",
    link: "3",
    tag: null,
  },
  {
    image: hm2,
    name: "HM",
    fullname: "High Molecular Plastic",
    link: "4",
    tag: null,
  },
];

const Section3 = () => {
  function scrollUp() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  return (
    <Container>
      {/* Section header */}
      <SectionHeader>
        <HeaderLeft>
          <SectionTag>Our Products</SectionTag>
          <SectionTitle className="sub-hero-text2">
            Four Lines. One Source.
          </SectionTitle>
        </HeaderLeft>
        <HeaderRight>
          <SectionDesc>
            Premium plastic packaging films manufactured to consistent quality
            standards, with custom printing available across all product lines.
          </SectionDesc>
          <ViewAllLink onClick={scrollUp} to="products">
            View all products &rarr;
          </ViewAllLink>
        </HeaderRight>
      </SectionHeader>

      {/* Product grid */}
      <ProductGrid>
        {products.map((p, i) => (
          <ProductCard key={i} to={`/product/${p.link}`} onClick={scrollUp}>
            <CardImageArea>
              <img src={p.image} alt={p.name} />
              {p.tag && <CardTag>{p.tag}</CardTag>}
            </CardImageArea>
            <CardBody>
              <CardName>{p.name}</CardName>
              <CardFullName>{p.fullname}</CardFullName>
              <CardLink>View details &rarr;</CardLink>
            </CardBody>
          </ProductCard>
        ))}
      </ProductGrid>
    </Container>
  );
};

const Container = styled.div`
  padding: 80px;
  background: var(--color-bg);
  border-top: 1px solid var(--color-border);

  @media (max-width: 768px) {
    padding: 48px 24px;
  }
`;

const SectionHeader = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 48px;
  margin-bottom: 56px;
  align-items: end;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 20px;
    margin-bottom: 36px;
  }
`;

const HeaderLeft = styled.div``;

const SectionTag = styled.span`
  display: block;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 2.5px;
  text-transform: uppercase;
  color: var(--color-muted);
  margin-bottom: 12px;
`;

const SectionTitle = styled.h2`
  margin: 0;
`;

const HeaderRight = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;
  gap: 20px;
`;

const SectionDesc = styled.p`
  font-size: 15px;
  color: var(--color-muted);
  line-height: 1.75;
  margin: 0;
`;

const ViewAllLink = styled(Link)`
  text-decoration: none;
  font-size: 14px;
  font-weight: 600;
  color: var(--color-brand);
  letter-spacing: 0.3px;
  transition: var(--transition);

  &:hover {
    color: #3348c4;
  }
`;

const ProductGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2px;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-card);
  overflow: hidden;

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

const ProductCard = styled(Link)`
  text-decoration: none;
  background: var(--color-bg);
  display: block;
  transition: var(--transition);
  border-right: 1px solid var(--color-border);
  position: relative;

  &:last-child { border-right: none; }

  &:hover { background: var(--color-bg-subtle); }

  @media (max-width: 900px) {
    border-right: 1px solid var(--color-border);
    border-bottom: 1px solid var(--color-border);
    &:nth-child(2n) { border-right: none; }
    &:nth-last-child(-n+2) { border-bottom: none; }
  }
`;

const CardImageArea = styled.div`
  height: 200px;
  overflow: hidden;
  background: var(--color-bg-subtle);
  border-bottom: 1px solid var(--color-border);
  position: relative;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.4s ease;
    display: block;
  }

  ${ProductCard}:hover & img {
    transform: scale(1.06);
  }
`;

const CardTag = styled.span`
  position: absolute;
  top: 12px;
  left: 12px;
  background: var(--color-dark);
  color: white;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
  padding: 4px 10px;
  border-radius: 2px;
`;

const CardBody = styled.div`
  padding: 20px 24px 24px;
`;

const CardName = styled.h3`
  font-size: 20px;
  font-weight: 800;
  color: var(--color-dark);
  margin: 0 0 4px;
  letter-spacing: -0.3px;
`;

const CardFullName = styled.p`
  font-size: 12px;
  color: var(--color-muted);
  margin: 0 0 16px;
  line-height: 1.4;
`;

const CardLink = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: var(--color-brand);
  letter-spacing: 0.3px;
`;

export default Section3;
